import React, { useCallback, useContext, useEffect, useState } from 'react';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../ContextApi/ContextApi';
import axios from 'axios';
import { basePath, formatDate } from '../Constants/constant';
import EditCandidate from '../Usables/EditCandidate';
import { IoChevronBackOutline } from "react-icons/io5";
import InputField from '../Usables/InputField';
import BasicButton, { DownloadButton } from '../Usables/Buttons';
import Loader from '../Usables/Loader';
import NoRecords from '../Usables/NoRecords';
import Pagination from '../Usables/Pagination';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useLocation, useParams } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SourcedCandidate = () => {
    const navigate = useNavigate();
    const query = useQuery();
    const fromDateDas = query.get("fromDate");
    const toDateDas = query.get("toDate");
    const { apiHeaderJSON } = useContext(AppContext);
    const [rows, setRows] = useState([]);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [filterData, setFilterData] = useState({
        fromDate:fromDateDas ? fromDateDas : "",
        toDate:toDateDas ? toDateDas : "",
        candidate:"",
        email:"",
        position:""
    });
    const [viewCandidate, setViewCandidate] = useState(false);
    const [formData, setFormData] = useState({candidate_resume: null,});
    const [ischanged, setIschanged] = useState({getListChanged: false});

    const getList = useCallback(async()=> {
        try {
            const options = {
                params: {
                    limit: pagination?.limit,
                    page: pagination?.page,
                    filter: filterData,
                },
                headers: apiHeaderJSON,
            } 
            const res = await axios.get(`${basePath}/GetAllCandidates`,options);
            // console.log("getfilteredupdatebypage===>", res.data);
            setRows(res.data?.Candidates);
            setPagination({...pagination, totalPages: res?.data?.pages, totalRecords: res?.data?.totalRecords});
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.log(error);
        }
    },[pagination, filterData, apiHeaderJSON]);

    useEffect(()=> {
        setLoading("1");
        getList();
    },[]);

    useEffect(() => {
        if(ischanged?.getListChanged){
            // console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged?.getListChanged]);

    const downloadButton = async (canId, candidateName) => {
        try {
            Swal.fire({
                title: 'Please wait...',
                html: 'Deleting...',
                allowOutsideClick: false,
                didOpen: () => {Swal.showLoading();}
            });
            const response = await fetch(`${basePath}/downloadresume/${canId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${candidateName.replace(/ /g, "_")}_resume_${formatDate(new Date())}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
            Swal.close();
        } catch (error) {
            Swal.close();
            console.error('There was a problem with the download:', error);
            toast.error(error?.response?.data?.error || "There was a problem with the download");
        }
    }

    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });       
    },[filterData]);

    const handleClose = ()=> {
        // console.log("onClose out");
        setFormData({});
        setViewCandidate(false);
    }

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);

    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({fromDate: "", toDate: "", candidate: "", email: "", position: "", recruiter: "", status: "",});
        setIschanged({...ischanged, getListChanged: true});
    },[ischanged]);

    // handling edit button 
    const handleEdit = (val) => {
        // console.log("edit val =>", val);
        setFormData({
            id: val?.id,
            candidate: val?.candidate || "",
            candidate_email: val?.candidate_email || "",
            phone_code: val?.phone_code || "",
            candidate_phone: val?.candidate_phone || "",
            phone_alt_code: val?.phone_alt_code || "",
            candidate_alt_phone: val?.candidate_alt_phone || "",
            candidate_location: val?.candidate_location || "",
            candidate_qualification: val?.candidate_qualification || "",
            current_currency_code: val?.current_currency_code || "",
            candidate_current_ctc: val?.candidate_current_ctc || "",
            candidate_ectc_type: val?.candidate_ectc_type || "",
            expected_currency_code: val?.expected_currency_code || "",
            candidate_expected_ctc: val?.candidate_expected_ctc || "",
            candidate_dob: val?.candidate_dob || "",
            candidate_industry: val?.candidate_industry || "",
            candidate_organization: val?.candidate_organization || "",
            candidate_designation: val?.candidate_designation || "",
            candidate_experience: val?.candidate_experience || "",
            candidate_notice_period: val?.candidate_notice_period || "",
            candidate_gender: val?.candidate_gender || "",
            candidate_resume: val?.resume_link || "",
            position_questions: val?.CandidateQnAs || [],
        });
        setViewCandidate(val)
    }

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }

    const handleCheckStatus = (value)=> {
        const statusList = [
        {name: "Sent To Client", className: "rounded-lg text-green-500 bg-green-100"},
        {name: "CV On Hold", className: "rounded-lg text-amber-500 bg-amber-100"},
        {name: "Confirmation Pending", className: "rounded-lg text-amber-500 bg-amber-100"},
        {name: "Shortlisted", className: "rounded-lg text-green-700 bg-green-200"},
        {name: "Final Selection", className: "rounded-lg text-green-500 bg-green-100"},
        {name: "Final Joining", className: "rounded-lg text-green-700 bg-green-200"},
        {name: "Rejected", className: "rounded-lg text-red-500 redBox"},
        {name: "Confirmation Pending", className: "rounded-lg text-green-500 greenBox"},
        {name: "Screened", className: "rounded-lg text-blue-500 blueBox"},
        {name: "CV Rejected", className: "rounded-lg text-red-500 redBox"}, 
        {name: "Duplicate CV", className: "rounded-lg text-white rounded-lg bg-yellow-700"},
        {name: "Backout", className: "rounded-lg text-red-700 redBox"}, 
        {name: "Blacklist", className: "rounded-lg text-red-700 redBox"}, 
        {name: "Rejected Post Interview", className: "rounded-lg text-red-500 redBox"},
        {name: "Interview Scheduled", className: "rounded-lg bg-purple-200 text-purple-800"}, 
        {name: "Interview Feedback Pending", className: "rounded-lg text-amber-800 bg-amber-300"},
        {name: "Shortlisted Next Round", className: "rounded-lg text-blue-500 blueBox"}, 
        {name: "Hold Post Interview", className: "rounded-lg text-yellow-500 yellowBox"},
    ];
        return statusList.find(status => status?.name === value) || false;
    }

    const handleDownload = async () => {
        try {
            const response = await fetch(`${basePath}/downloadresume/${formData?.id}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${formData?.candidate.replace(/ /g, "_")}_resume_${formatDate(new Date())}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
        } catch (error) {
            console.error('There was a problem with the download:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There was a problem with the download");
            }
        }
    }

    return (
        <section className='  w-full'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            {/* PageBanner => used to show page banner info */}
            <PageBanner pageName='Sourced Candidates' pageTitle='Ready to start your day' src='/img/master.png' alt="screened candidate" />
            {viewCandidate && 
                (<div className=' w-full h-screen fixed left-0 top-0 z-40 flex items-center justify-center blurBack'>
                    <div className=' bg-white overflow-auto mx-10 mb-5 p-10 rounded-3xl candidateInfoBox'>
                        <EditCandidate
                        onClose={handleClose}
                        onDownload={handleDownload}
                        OnlyView={true}
                        data={formData}
                        disabled={true}
                        />
                    </div>
                </div>)}
            {/* filter */}
                <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                    <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                    value={filterData?.fromDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To:"
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="candidate" name="candidate" type="text" label="Candidate:"
                    placeholder="Enter Candidate"
                    value={filterData?.candidate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="email" name="email" type="text" label="Email:"
                    placeholder="Enter Email"
                    value={filterData?.email}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="position" name="position" type="text" label="Position:"
                    placeholder="Enter Position"
                    value={filterData?.position}
                    onChange={handleChangeFilter}
                    />
                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.email && !filterData?.position && !filterData?.recruiter && !filterData?.status)} 
                            loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.email && !filterData?.position && !filterData?.recruiter && !filterData?.status)} 
                            loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                        <div onClick={()=> {navigate(-1)}} className='darkPurple w-fit cursor-pointer rounded-lg py-2 px-3 mt-7 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation'>
                            <IoChevronBackOutline className=' text-xl text-white' />
                            <button>Back</button>
                        </div>
                    </div>
                </div>
            {
                loading === "1" ?
                <Loader/> :
                Array.isArray(rows) && rows?.length >= 1 ?
                <section className='tableWrapper'>
                    <div className='tableBody'>
                        <table className='w-full table-fixed border-collapse'>
                            <thead className='tableHead'>
                                <tr className=' text-left'>
                                    <th className='cursor-pointer w-48'>Sent Date</th>
                                    <th  className=' whitespace-nowrap text-center w-52'>Current Status</th>
                                    <th className=' whitespace-nowrap ' >Candidate</th>
                                    <th className=' whitespace-nowrap' >Position</th>
                                    <th className=' whitespace-nowrap text-center w-[10%]' >Relevent</th>
                                    <th className=' whitespace-nowrap text-center w-[10%]' >Resume</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Array.isArray(rows) && rows?.map((val, idx) => {
                                        return (
                                            <tr key={val?.id} id={val?.id} className='font-semibold text-sm text-left'>
                                                <td>
                                                    <span className='line-clamp-1 text-ellipsis'>{val?.sourcing_date ? formatDate(val?.sourcing_date) : "--"}</span>
                                                    <span className='line-clamp-1 text-ellipsis text-green-600'>{val?.User?.name}</span>
                                                    </td>
                                                <td>
                                                    <h3 className={`line-clamp-1 text-ellipsis w-full text-center text-nowrap outline-none border border-gray-300 py-2.5 px-1 ${val?.candidate_status ? handleCheckStatus(val?.candidate_status)?.className : handleCheckStatus(val?.sourcing_status)?.className}`}>
                                                        { val?.candidate_status ? handleCheckStatus(val?.candidate_status)?.name : handleCheckStatus(val?.sourcing_status)?.name}
                                                    </h3>
                                                </td>
                                                <td className=' whitespace-nowrap'>
                                                    <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.candidate && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> { if (val?.candidate) handleEdit(val)}}>{val?.candidate || "--"}</span>
                                                    <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.candidate_email ? val?.candidate_email : "NA"}</span>
                                                </td>
                                                <td className=' whitespace-nowrap'>
                                                    <span className='line-clamp-1 text-ellipsis' >{val?.Position?.position}</span>
                                                    <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.Position?.Company.company_name}</span>
                                                </td>
                                                <td className='whitespace-nowrap text-center'>
                                                    <div className={` whitespace-nowrap py-2 px-1 border border-gray-300  ${val?.relevant === "Yes" ? " text-green-500 greenBox" : "text-red-600 redBox"}`} >
                                                        {val?.relevant}</div>
                                                </td>
                                                <td className=' text-center'>
                                                    <DownloadButton data={val} onClick={()=> downloadButton(val?.id, val?.candidate)} tooltipName="Download Resume" disabled={!val?.resume_link} />
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                    limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                    disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                    />
                </section> :
                <NoRecords/>
            }
        </section>
    );
}

export default SourcedCandidate;
